"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const useMergeRefs_1 = __importDefault(require("../../../hooks/useMergeRefs"));
const TabPanelsConstants_1 = require("./TabPanelsConstants");
require("./TabPanels.scss");
const TabPanels = (0, react_1.forwardRef)(({ className, id, activeTabId = 0, animationDirection = TabPanelsConstants_1.TabPanelsAnimationDirection.RTL, children, renderOnlyActiveTab = false // TODO BREAKING change to true - breaking change
 }, ref) => {
    const componentRef = (0, react_1.useRef)(null);
    const mergedRef = (0, useMergeRefs_1.default)({ refs: [ref, componentRef] });
    const renderedTabs = (0, react_1.useMemo)(() => {
        return react_1.default.Children.map(children, (child, index) => {
            const isActiveTab = activeTabId === index;
            if (renderOnlyActiveTab && !isActiveTab)
                return null;
            const activeClass = isActiveTab ? "active" : "non-active";
            const animationClass = isActiveTab ? `animation-direction-${animationDirection}` : "";
            return react_1.default.cloneElement(child, Object.assign(Object.assign({ index }, child.props), { className: (0, classnames_1.default)("tab-panel", activeClass, animationClass, child.props.className) }));
        }).filter(Boolean);
    }, [children, activeTabId, renderOnlyActiveTab, animationDirection]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ ref: mergedRef, className: (0, classnames_1.default)("tab-panels--wrapper", className), id: id }, { children: renderedTabs })));
});
Object.assign(TabPanels, {
    isTabPanels: true,
    animationDirections: TabPanelsConstants_1.TabPanelsAnimationDirection
});
exports.default = TabPanels;
